/**
 * src/api/billing.js
 * Funciones para billing Flow.cl.
 *
 * Flujo:
 * 1. crearCheckout(tier) → {url, customer_id} → redirigir a url (Flow registra tarjeta)
 * 2. Flow redirige a /billing/flow-callback?token=...&tier=...&usuario_id=...
 * 3. Backend verifica + suscribe → redirige a /onboarding
 */
import api from './client'

export const crearCheckout = (tier, ciclo = 'mensual') =>
  api.post('/billing/checkout', { tier, ciclo }).then(r => r.data)

export const abrirPortal = () =>
  api.get('/billing/portal').then(r => r.data)

export const getSuscripcion = () =>
  api.get('/billing/suscripcion').then(r => r.data)

// Sonda read-only (admin): verifica los planes en Flow sin mover dinero.
export const verificarPlanesFlow = () =>
  api.get('/billing/admin/planes').then(r => r.data)

// Diagnóstico read-only (admin): trae de Flow una suscripción ya existente.
export const diagnosticoFlow = () =>
  api.get('/billing/admin/flow-diag').then(r => r.data)

// Reconciliación (admin): consulta Flow y activa las suscripciones ya pagadas
// cuyo webhook no llegó. Idempotente. Sin arg → todas las no-activas.
// forzar=true (exige subscriptionId): activa aunque Flow no confirme el pago
// (discrepancia probada Flow↔banco).
export const reconciliarFlow = (subscriptionId, forzar = false) => {
  const qs = new URLSearchParams()
  if (subscriptionId) qs.set('subscription_id', subscriptionId)
  if (forzar) qs.set('forzar', 'true')
  const s = qs.toString()
  return api.post('/billing/admin/reconciliar' + (s ? `?${s}` : '')).then(r => r.data)
}

export const completarOnboarding = (data) =>
  api.post('/billing/onboarding', data).then(r => r.data)

export const registerUser = (data) =>
  api.post('/auth/register', data).then(r => r.data)

export const loginUser = (data) =>
  api.post('/auth/login', data).then(r => r.data)

export const getMe = () =>
  api.get('/auth/me').then(r => r.data)

export const cambiarPassword = (actual, nueva) =>
  api.post('/auth/change-password', { actual, nueva }).then(r => r.data)
